import React, { useEffect, useRef } from 'react';

export default function TvCanvas({
  children,
  designWidth = 1920,
  designHeight = 1080,
  contain = true,      // true = letterbox (no cropping), false = cover (crop)
  enabled = true,      // only enable on Fire TV / kiosk routes
  style = {}
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (!enabled || !ref.current) return;

    const el = ref.current;
    const fit = () => {
      const W = designWidth;
      const H = designHeight;
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const sx = vw / W;
      const sy = vh / H;
      const s = contain ? Math.min(sx, sy) : Math.max(sx, sy);

      // center with letterboxing
      const left = Math.floor((vw - W * s) / 2);
      const top  = Math.floor((vh - H * s) / 2);

      el.style.transform = `translate(${left}px, ${top}px) scale(${s})`;
    };

    // first fit + on resize
    fit();
    window.addEventListener('resize', fit);
    const id = setInterval(fit, 500); // safety for TV UI blips
    return () => { window.removeEventListener('resize', fit); clearInterval(id); };
  }, [enabled, contain, designWidth, designHeight]);

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        overflow: 'hidden',
        background: '#000',
        // host layer — nothing to scale here
      }}
    >
      <div
        ref={ref}
        style={{
          width: designWidth,
          height: designHeight,
          transformOrigin: 'top left',
          // keep your own styles on the inner content
          ...style
        }}
      >
        {children}
      </div>
    </div>
  );
}
